import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import "./AddCardModal.css";

const AddCardModal = ({ onClose, onSuccess, apiBaseUrl }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [setAsDefault, setSetAsDefault] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("ogestyle_token");
      const headers = { Authorization: `Bearer ${token}` };

      // Create Setup Intent
      const setupIntentRes = await axios.post(
        `${apiBaseUrl}/api/subscription-new/payment-methods/setup-intent`,
        {},
        { headers },
      );

      const { clientSecret } = setupIntentRes.data;

      // Confirm card setup
      const { error: stripeError, setupIntent } = await stripe.confirmCardSetup(
        clientSecret,
        {
          payment_method: {
            card: elements.getElement(CardElement),
          },
        },
      );

      if (stripeError) {
        setError(stripeError.message);
        setLoading(false);
        return;
      }

      // Attach payment method to customer
      await axios.post(
        `${apiBaseUrl}/api/subscription-new/payment-methods`,
        {
          paymentMethodId: setupIntent.payment_method,
          setAsDefault: setAsDefault,
        },
        { headers },
      );

      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to add card");
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content add-card-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>💳 Add Payment Method</h2>
          <button className="btn-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Card Details</label>
              <div className="card-element-wrapper">
                <CardElement
                  options={{
                    style: {
                      base: {
                        fontSize: "16px",
                        color: "#424770",
                        "::placeholder": {
                          color: "#aab7c4",
                        },
                      },
                      invalid: {
                        color: "#9e2146",
                      },
                    },
                  }}
                />
              </div>
            </div>

            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  checked={setAsDefault}
                  onChange={(e) => setSetAsDefault(e.target.checked)}
                />
                <span>Set as default payment method</span>
              </label>
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="modal-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn-primary"
                disabled={!stripe || loading}
              >
                {loading ? "Adding..." : "Add Card"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCardModal;
